import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import {
  add_incentive_slab,
  update_incentive_slab,
} from "../../../../data/ApiEndpoints";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.minSlabAmount) {
    errors.minSlabAmount = "Required!";
  } else if (
    Number(formValues.minSlabAmount) > Number(formValues.maxSlabAmount)
  ) {
    errors.minSlabAmount = "Required!";
    errors.maxSlabAmount = "Required!";
  }

  if (!formValues.maxSlabAmount) {
    errors.maxSlabAmount = "Required!";
  }

  if (!formValues.slabPercentage) {
    errors.slabPercentage = "Required!";
  }

  return errors;
};

const IncentiveSlabForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const forminitials = {
    minSlabAmount: isEdit && rowData?.min_amount ? rowData.min_amount : "",
    maxSlabAmount: isEdit && rowData?.max_amount ? rowData.max_amount : "",
    slabPercentage: isEdit && rowData?.percentage ? rowData.percentage : "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_incentive_slab : add_incentive_slab;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        min_amount: formValues.minSlabAmount || "",
        max_amount: formValues.maxSlabAmount || "",
        percentage: formValues.slabPercentage || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(handleConfirm, ` `, "Edit Form", "Submit Form");
    }
  }, [isSubmit, formErrors]);

  return (
    <div className={`createNewCTOModalContainer mod-width-50p`}>
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add New"} Slab`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="minSlabAmount" className={`formInputLabel `}>
              Slab Range <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Min Amount"
              className={`formInput ${
                formErrors?.minSlabAmount ? "formError" : ""
              }`}
              name="minSlabAmount"
              value={formValues.minSlabAmount}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="maxSlabAmount" className={`formInputLabel `}>
              <br />
            </label>

            <input
              type="number"
              placeholder="Max amount"
              className={`formInput ${
                formErrors?.maxSlabAmount ? "formError" : ""
              }`}
              name="maxSlabAmount"
              value={formValues.maxSlabAmount}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="slabPercentage" className={`formInputLabel `}>
              Slab Percentage <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Percentage"
              className={`formInput ${
                formErrors?.slabPercentage ? "formError" : ""
              }`}
              name="slabPercentage"
              value={formValues.slabPercentage}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default IncentiveSlabForm;
